import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.4152 11.2501H10.8829C11.2971 11.2501 11.6329 11.5858 11.6329 12.0001C11.6329 12.4143 11.2971 12.7501 10.8829 12.7501H4.41522L2.81343 18.7974C2.61703 19.5396 2.8736 20.3281 3.46919 20.8125C4.06478 21.297 4.88893 21.3876 5.57558 21.0442L20.1735 13.7471C20.8354 13.4164 21.2535 12.74 21.2535 12.0001C21.2535 11.2602 20.8354 10.5838 20.1735 10.2531L5.5755 2.95592C4.88886 2.61256 4.06476 2.70323 3.46919 3.18767C2.8736 3.67213 2.61708 4.46072 2.81347 5.20292L4.4152 11.2501Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgSendFilled);
export default ForwardRef;
